import React from 'react';
import PropTypes from 'prop-types';
import { BreadcrumbJsonLd } from 'next-seo';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import { useRouter } from 'next/router';
import { withTranslation } from '../../src/i18n';
import routesWithTitle from '../../constants/routesWithTitle';
import NextLink from '../NextLink';
const baseURL = process.env.FRONTBASE_URL;

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 12,
  },
  listItem: {
    fontSize: 12,
    fontWeight: 300,
    color: 'rgba(0, 0, 0, 0.53)',
    textDecoration: 'none',
  },
  activeListItem: {
    color: '#f36d2a',
    fontWeight: 'bold',
    fontSize: 12,
  },
}));

const CustomSeparator = ({ customBreadcrumbs, t }) => {
  const classes = useStyles();
  const router = useRouter();

  if (router.pathname === routesWithTitle.HOME.path) return null;

  const links = customBreadcrumbs || [];

  const isNotLastItem = index => index !== links.length - 1;
  const itemListElements = [];

  return (
    <div className={classes.root}>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {links.map((link, index) => {
          itemListElements.push({
            position: index + 1,
            name: t(link.title),
            item: `${baseURL.replace(/\/$/, '')}${link.path}`,
          });
          if (isNotLastItem(index) || links.length === 1) {
            return (
              <NextLink href={link.path} key={link.title} className={classes.listItem}>
                {t(link.title)}
              </NextLink>
            );
          }
          return (
            <Typography color="textPrimary" className={classes.activeListItem} key={link.title}>
              {t(link.title)}
            </Typography>
          );
        })}
      </Breadcrumbs>
      <br />
      <BreadcrumbJsonLd itemListElements={itemListElements} />
    </div>
  );
};

CustomSeparator.getInitialProps = async () => ({
  namespacesRequired: ['translation'],
});

CustomSeparator.propTypes = {
  t: PropTypes.func.isRequired,
  customBreadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
};

export default withTranslation('translation')(CustomSeparator);
